import { ServiceType } from '@uipath/portal-shell-util';

import { Scope } from '../constants/constants';
import { isNonEmptyString } from '../utils/helper';
import { t } from '../utils/localization/loc';

export interface Service {
    docId?: string;
    id: string;
    name: string;
    icon?: string;
    svg?: string;
    url: string;
    active?: boolean;
    handled?: boolean;
    scope: Scope;
    serviceType: ServiceType;
    showInHostAccount?: boolean;
    showBadge?: boolean;
    serviceClickHandler?: (event: any) => void;
    isMore?: boolean;
}

export namespace Service {
    export const documentationUrl = (service: Service): string | null => {
        const docId = service.docId;

        if (isNonEmptyString(docId)) {
            return `https://docs.uipath.com/${docId}`;
        }

        return null;

    };

    export const documentationTitle = (service: Service, locale: string) => {
        // If there is no per-service documentation, just use the
        // default 'Documentation' string
        if (documentationUrl(service) == null) {
            return t('help-menu-documentation', locale);
        }

        return t('help-menu-product-documentation', locale, { product: service.name });
    };
}
